import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import "./PodcastPage.css";
import { BASE_URL } from "../../config/baseUrl";

const fallbackThumbnail = `${process.env.PUBLIC_URL}/assets/img/podcast-fallback.jpg`;

function PodcastPage() {
  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    fetch(`${BASE_URL}/Podcast`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        setEpisodes(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching podcasts:", err);
        setLoading(false);
      });
  }, []);

  // Returns proper thumbnail URL
  const getThumbnailUrl = (ep) => {
    if (!ep.youtubeId) return fallbackThumbnail;
    return `https://img.youtube.com/vi/${ep.youtubeId}/hqdefault.jpg`;
  };

  const renderThumbnail = (ep) => (
    <div className="video-thumbnail" onClick={() => setActiveVideo(ep.podcastId)}>
      <img
        src={getThumbnailUrl(ep)}
        alt={ep.title}
        className="img-fluid rounded"
      />
      <div className="play-button">▶</div>
    </div>
  );

  const renderIframe = (ep) => (
    <div className="ratio ratio-16x9">
      <iframe
        src={`https://www.youtube.com/embed/${ep.youtubeId}?autoplay=1`}
        title={ep.title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );

  return (
    <>
      <Navbar />

      {/* Hero Banner */}
      <section className="podcast-hero d-flex align-items-center">
        <div className="container text-center">
          <h1>🎙️ Our Podcasts</h1>
          <p>Learn, grow & get inspired by real stories</p>
        </div>
      </section>

      <main className="main podcast-page">
        <div className="container">
          {loading ? (
            <p className="loading-text">Loading podcasts...</p>
          ) : episodes.length === 0 ? (
            <p className="empty-text">No podcasts available at the moment.</p>
          ) : (
            <div className="row">
              {episodes.map((ep) => (
                <div key={ep.podcastId} className="col-lg-4 col-md-6 mb-4">
                  <div className="episode-card h-100">
                    {activeVideo === ep.podcastId ? renderIframe(ep) : renderThumbnail(ep)}

                    <div className="p-3">
                      <h4>{ep.title}</h4>
                      <p className="meta">
                        {ep.releaseDate
                          ? new Date(ep.releaseDate).toLocaleDateString()
                          : "Date not available"}{" "}
                        • {ep.duration || "N/A"} mins
                      </p>
                      <p>{ep.description ? ep.description.slice(0, 100) + "..." : ""}</p>

                      {ep.youtubeId ? (
                        <a
                          href={`https://www.youtube.com/watch?v=${ep.youtubeId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn-watch"
                        >
                          ▶ Watch on YouTube
                        </a>
                      ) : (
                        <button className="btn-watch btn-disabled" disabled>
                          ▶ Not Available
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}

export default PodcastPage;
